/*
 *  Author: DL
 *  Date: 2020-12-05 22:18:37
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 11:33:54
 *  LastEditors: DL
 *  Description: 地图选择页面
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import classnames from 'classnames';
import { Button, Icon, Alert } from 'ui';
import ZoomControl from '@/components/ZoomControl';
import FloorControl from '@/components/FloorControl';
import ViewModeControl from '@/components/ViewModeControl';
import LayerModeControl from '@/components/LayerModeControl';
import LocationControl from '@/components/LocationControl';
import FmapProvider from '@/components/FmapProvider';
import { isEmpty } from 'utils/tools';
import styles from './index.less';

function Select(props) {
    const { dispatch, location } = props;
    const { fmap, listGroups, focusGroupId, visibleModel } = props;
    const { focusModel, coords } = props.map;

    const [visible, setVisible] = useState(false);

    const handleCloseInfo = useCallback(() => dispatch({ type: 'map/updateFocusModel', payload: { focusModel: {} } }), [dispatch]);

    const handleBackClick = useCallback(() => router.push('/route'), []);

    const handleConfirm = useCallback(() => {
        const { field } = location.query;

        const { start = {}, end = {} } = { ...coords, [`${field}`]: focusModel };

        if (start.FID === end.FID) {
            setVisible(true);
        } else {
            dispatch({ type: 'map/updateCoordField', payload: { field, model: { ...focusModel } } });
            dispatch({ type: 'map/updateFocusModel', payload: {} })

            if (isEmpty(start) || isEmpty(end)) {
                router.push(`/route`);
            } else {
                router.push(`/scheme`);
            }
        }
    }, [location, coords, focusModel, dispatch]);

    const mapClickNode = useCallback(
        event => {
            if (!event.target) return;

            const {
                mapCoord: { x, y },
                target: { FID, groupID, name, label = {} },
            } = event;

            if (!label.name) return;

            const floor = fmap.getFloorBygroupID(groupID);

            dispatch({ type: 'map/updateFocusModel', payload: { focusModel: { x, y, FID, groupID, name: name ? name.replace(/\%rn\%/, '') : '', floor } } });

            // 当前positionMarker
            const coordCenter = fmap.getMapCoordToCenter(FID);
            if (coordCenter) {
                fmap.updatePositionMarker(coordCenter);
            }
        },
        [dispatch, fmap],
    );

    useEffect(() => {
        if (fmap) {
            fmap.map.on('mapClickNode', mapClickNode);

            return () => {
                fmap.map.off('mapClickNode', mapClickNode);
                fmap.visibleUpdatePositionMarke(false);
            };
        }
    }, [fmap, mapClickNode]);

    return (
        <FmapProvider value={{ fmap, listGroups, focusGroupId, visibleModel }}>
            <Alert visible={visible} message="起点和终点不能相同" onClose={() => setVisible(false)} />
            <div className={styles.titleWrapper}>
                <Button className={styles.bttnBack} onClick={handleBackClick}>
                    <Icon className="iconBack" />
                </Button>
                <Icon className={classnames(['iconmap', styles.icon])} />
                地图选点
            </div>
            <div className={styles.controlWrapper}>
                <LocationControl />
                <LayerModeControl />
                <ViewModeControl />
                <FloorControl />
                <ZoomControl />
            </div>
            <InfoModal data={focusModel} onCloseClick={handleCloseInfo} onConfirmClick={handleConfirm} />
        </FmapProvider>
    );
}

function InfoModal(props) {
    const { data } = props;

    if (isEmpty(data)) return null;

    const { name, floor } = data;

    return (
        <div className={styles.infoWrapper}>
            <div className={styles.content}>
                <span>
                    {name} {floor}
                </span>
                <Button className={styles.close} onClick={props.onCloseClick}>
                    <Icon className="icongb002" />
                </Button>
            </div>
            <Button block type="primary" onClick={props.onConfirmClick}>
                确认选点
            </Button>
        </div>
    );
}

export default connect(({ map }) => ({ map }))(Select);
